import { UploadCloud } from 'lucide-react';

interface DragDropOverlayProps {
  visible: boolean;
}

export function DragDropOverlay({ visible }: DragDropOverlayProps) {
  if (!visible) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-2xl border border-dashed border-primary/40 bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-2xl bg-background/90 px-6 py-8 text-center shadow-xl">
        <UploadCloud className="h-10 w-10 text-primary" />
        <div>
          <p className="text-base font-medium text-foreground">Déposez vos fichiers ici</p>
          <p className="text-sm text-muted-foreground">Images, vidéos et documents</p>
        </div>
      </div>
    </div>
  );
}
